/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { SocialWebTimelineWidget } from 'schemas/SocialWebTimelineWidgetSchema'

const MeasureTypesAndMetricNamesEmptyGuard: WidgetGuard = ({ widgetId, children }) => {
  const { measureTypes, metricNames } = useDashboardWidgetSetting<SocialWebTimelineWidget>(widgetId)
  const { t } = useTranslation()

  if (!(measureTypes?.length || metricNames?.length))
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default MeasureTypesAndMetricNamesEmptyGuard
